import { useEffect } from "react";
import { copyText, scrollWindowTop } from "../../../utils/Common/Constant";
import { useTranslation } from "react-i18next";

interface ResourceDetailsProps {
  contractDetails: any;
}
const VendorsDetails = ({ contractDetails }: ResourceDetailsProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    scrollWindowTop();
  }, []);
  return (
    <div className="vendorsDetailsSec">
      <div className="contractVendorDetail">
        <div className="profileMeta">
          <div className="row">
            <div className="col-md-4">
              <div className="w-100 mb-5">
                <p className="metaLabel">{t("CONTRACT.MANAGER")}</p>
                <h5 className="metaValue">
                  {contractDetails?.partnerUserName
                    ? contractDetails?.partnerUserName
                    : "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-4">
              <div className="w-100 mb-5">
                <p className="metaLabel">{t("CONTRACT.VENDOR")}</p>
                <h5 className="metaValue">
                  {contractDetails?.partnerCompanyName
                    ? contractDetails?.partnerCompanyName
                    : "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-4">
              <div className="w-100 mb-5">
                <p className="metaLabel">{t("CONTRACT.VENDOR_EMAIL")}</p>
                <h5
                  className="metaValue cursorPointer"
                  onClick={() =>
                    copyText(contractDetails?.["partnerCompany.email"])
                  }
                >
                  {contractDetails?.["partnerCompany.email"]
                    ? contractDetails?.["partnerCompany.email"]
                    : "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-4">
              <div className="w-100 mb-5">
                <p className="metaLabel">{t("GENERAL.COMPANY_LOCATION")}</p>
                <h5 className="metaValue">
                  {contractDetails?.companyCity +
                    ", " +
                    contractDetails?.companyState +
                    ", " +
                    contractDetails?.companyCountry}
                </h5>
              </div>
            </div>
            <div className="col-md-4">
              <div className="w-100 mb-5">
                <p className="metaLabel">{t("GENERAL.CONTACT_NUMBER")}</p>
                <h5 className="metaValue">
                  {contractDetails?.applicantMobile
                    ? contractDetails?.applicantMobile
                    : "-"}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorsDetails;
